import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ttm} from '../../classes/ttm';
import {Project} from '../../classes/project';
import {TtmType} from '../../classes/ttmtype';
import {TtmStatus} from '../../classes/ttmstatus';
import {CodaltComponent} from '../codalt/codalt.component';
import {FormBuilder} from '@angular/forms';
import {TtmTicket} from '../../classes/ttm-ticket.class';
import {TtmTicketService} from '../../services/ttm-ticket.service';

@Component({
    selector: 'app-ttm-details-dialog',
    templateUrl: './ttm-details-dialog.component.html',
    styleUrl: './ttm-details-dialog.component.scss'
})
export class TtmDetailsDialogComponent extends CodaltComponent implements OnInit {

    public form

    constructor(public dialogRef: MatDialogRef<TtmDetailsDialogComponent>,
                private formBuilder: FormBuilder,
                private ticketSrvc: TtmTicketService,
                @Inject(MAT_DIALOG_DATA) public data: {
                    ttm: Ttm,
                    project: Project,
                    ttmTypes: TtmType[],
                    ttmStatuses: TtmStatus[],
                    ticket: TtmTicket
                }) {
        super();
    }

    onClose(): void {
        this.dialogRef.close();
    }

    ngOnInit(): void {
        if (this.data.ticket) {
            this.form = this.formBuilder.group({
                comment: [this.data.ticket.comment]
            });
        }
    }

    save() {
        this.data.ticket.comment = this.form.get('comment').value;
        this.ticketSrvc.updateTicket(this.data.ticket.id, this.data.ticket).subscribe(() => {
            this.dialogRef.close();
        });
    }
}
